import Marquee from "react-fast-marquee";
import './App.css';

function App() {
  return (
    <div>
      <header className="App">
      <div className="top">
      { <Marquee speed={10} className='stripe' autoFill={true}>
      <header className='Stripe-Content'>COMING SOON</header>
      </Marquee> }
      </div>
      <div className="center">
      <div className="App-Text">BARIKANI</div>
      </div>
      <div className="bottom">
      { <Marquee speed={10} className='stripe' autoFill={true} direction="right">
      <header className='Stripe-Content'>COMING SOON</header>
      </Marquee> }
      </div>
      </header>
    </div>
  );
}

export default App;